import { RefObject, useSyncExternalStore } from "react";

function subscribe(callback: (e: Event) => void) {
	window.addEventListener("resize", callback);
	return () => {
		window.removeEventListener("resize", callback);
	};
}

export function useDimension(
	ref: RefObject<HTMLElement | null>,
	dimension: "width" | "height",
) {
	return useSyncExternalStore(subscribe, () => {
		if (!ref.current) return 0;
		return dimension === "width"
			? ref.current.offsetWidth
			: ref.current.offsetHeight;
	});
}
